import { HRMRoutes } from "./HRMRoutes";
import { InventoryRoutes } from "./InventoryRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { ProcurementRoutes } from "./ProcurementRoutes";

import Home from "@containers/Home";
import Layout from "@containers/Layout";
import NoMatch from "@containers/no-match";

import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";
import { TaskManagementRoutes } from "./TaskManagementRoutes";
import { TicketsRoutes } from "./TicketsRoutes";
import { NotificationRoutes } from "./NotificationRoutes";

export const Routes: RouteType[] = [
  ...PublicRoutes,

  // HOME MODULE
  {
    id: "1",
    path: ROUTES.HOME,
    element: <Layout />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
    children: [
      //HOME
      {
        id: "1.1",
        index: true,
        element: <Home />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },

      ...HRMRoutes,
      ...InventoryRoutes,
      ...ProcurementRoutes,
      ...TaskManagementRoutes,
      ...TicketsRoutes,
      ...NotificationRoutes,
    ],
  },
];
